import * as React from "react";
import { IToggleButtonProps } from ".";
import { Button, CaptionContainer } from "./ToggleButton.styles";

export const ToggleButton: React.FunctionComponent<IToggleButtonProps> =
    ({ UncheckedCaption, CheckedCaption, Disabled, OnClick, Toggled }: IToggleButtonProps) => {

        const [checked, setChecked] = React.useState(Toggled);

        React.useEffect(() => {
            setChecked(Toggled);
        }, [Toggled]);

        const toggleCheck = () => {
            const value = !checked;
            setChecked(value);
            OnClick(value);
        };

        return (
            <Button
                type="button"
                disabled={Disabled}
                onClick={!Disabled ? toggleCheck : undefined}
                Checked={Toggled}
                aria-pressed={Toggled}
            >
                <CaptionContainer>{checked ? CheckedCaption : UncheckedCaption}</CaptionContainer>
            </Button>
        );
    };
